import React, { useEffect, useState } from 'react';
import { Modal, ModalFooter } from 'reactstrap';
import { useSelector } from 'react-redux';

import { popUpClick, popUpView } from '../../../utils/trackingUtil';
import { POPUP_NAME } from '../../../constants/Constants';
import IMAGES from '../../../constants/Images';
import {
  ModalIcon,
  ModalTitle,
  ModalDescription,
  ModalReasonsContainer,
  ModalReasonsList,
  ModalBodyContainer,
} from './MicrophoneNotDetectedModal.style';

export default function MicrophoneNotDetectedModal({ isOpen }) {
  const [showModal, setShowModal] = useState(isOpen);
  const { test_type_verbose, productTypeSmall } = useSelector(
    state => state.test
  );

  useEffect(() => {
    if (isOpen) {
      popUpView({
        payload: {
          popUpTitle: POPUP_NAME.microphoneNotDetected,
          popUpAction: 'Microphone not detected info',
        },
      });
    }
    setShowModal(isOpen);
  }, [isOpen]);

  const handleProceedToTest = () => {
    setShowModal(false);
    popUpClick({
      payload: {
        popUpTitle: POPUP_NAME.microphoneNotDetected,
        popUpAction: 'Microphone not detected info',
        label: 'proceed to test',
      },
    });
  };

  return (
    <>
      <Modal backdrop="static" centered size="lg" isOpen={showModal}>
        <ModalBodyContainer>
          <ModalIcon src={IMAGES.MIC_NOT_FOUND} className="d-block mx-auto" />
          <div className="d-flex justify-content-center">
            <ModalTitle>Microphone Not Detected!</ModalTitle>
          </div>
          <ModalDescription>
            This {test_type_verbose} requires access to your microphone.
            Interference with microphone functioning will be reported to the
            admin and can affect your candidature.
          </ModalDescription>
          <ModalReasonsContainer>
            This issue could be because of one of the reasons:
            <ModalReasonsList>
              <li>Microphone permission disabled</li>
              <li>Another application could be using the microphone</li>
              <li>Browser is not able to detect the microphone</li>
            </ModalReasonsList>
          </ModalReasonsContainer>
        </ModalBodyContainer>
        <ModalFooter className="justify-content-center">
          <button
            type="button"
            onClick={handleProceedToTest}
            className="btn btn-primary"
          >
            proceed to {productTypeSmall}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}
